var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader",class:{ show: _vm.show }},[(_vm.show && !_vm.quoteLoader)?_c('i',{staticClass:"loader"}):_c('div',{staticClass:"carousel-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }